/**
 * O cone de incerteza do sistema selecionado está ligado? (pedido do usuário,
 * 09/10/2026: um botão discreto na ficha, na compacta e na completa.) Ligado
 * por padrão; a escolha fica lembrada no navegador, como as outras
 * preferências.
 */
import { create } from 'zustand';

const CHAVE = 'amaview:cone';

function ler(): boolean {
  try {
    return globalThis.localStorage?.getItem(CHAVE) !== '0';
  } catch {
    return true;
  }
}

function gravar(ligado: boolean): void {
  try {
    if (ligado) globalThis.localStorage?.removeItem(CHAVE);
    else globalThis.localStorage?.setItem(CHAVE, '0');
  } catch {
    // navegação privada / armazenamento bloqueado: só não lembra
  }
}

interface ConeState {
  ligado: boolean;
  setLigado: (ligado: boolean) => void;
}

export const useConeStore = create<ConeState>()((set) => ({
  ligado: ler(),
  setLigado: (ligado) => {
    gravar(ligado);
    set({ ligado });
  },
}));
